import { httpClient } from './httpClient';
import type {
  CreatePassRequest,
  UpdatePassRequest,
  CreatePassResponse,
  UpdatePassResponse,
  DeletePassResponse,
} from './types';

export const passesApi = {
  create: (clientId: string, data: CreatePassRequest): Promise<CreatePassResponse> => {
    return httpClient.post<CreatePassResponse>(`/v1/clients/${clientId}/passes`, data);
  },

  update: (passId: string, data: UpdatePassRequest): Promise<UpdatePassResponse> => {
    return httpClient.put<UpdatePassResponse>(`/v2/passes/${passId}`, data);
  },

  delete: (passId: string): Promise<DeletePassResponse> => {
    return httpClient.delete<DeletePassResponse>(`/v1/passes/${passId}`);
  },
} as const;
